interface Props {
    size?: "sm" | "md" | "lg";
    label?: string;
    center?: boolean;
    className?: string;
}

export function MkSpinner({ size = "md", label, center, className }: Props) {
    return (
        <div className={`mk-spinner-box${center ? " mk-spinner-center" : ""}${
            className ? ` ${className}` : ""}`}>
            <span className={`mk-spinner mk-spinner-${size}`} />
            {label && <span className="mk-spinner-label">{label}</span>}
        </div>
    );
}
